import { createContext, useState, useCallback, useMemo } from "react";
import merge from "lodash/merge";
// CUSTOM COMPONENT
import { MatxLayoutSettings } from "app/components/MatxLayout/settings";

export const SettingsContext = createContext({
  settings: MatxLayoutSettings,
  updateSettings: () => {},
});

export default function SettingsProvider({ settings, children }) {
  const [currentSettings, setCurrentSettings] = useState(settings || MatxLayoutSettings);

  const handleUpdateSettings = useCallback((update = {}) => {
    setCurrentSettings((prevSettings) => merge({}, prevSettings, update));
  }, []);

  const contextValue = useMemo(
    () => ({
      settings: currentSettings,
      updateSettings: handleUpdateSettings,
    }),
    [currentSettings, handleUpdateSettings]
  );

  return (
    <SettingsContext.Provider value={contextValue}>
      {children}
    </SettingsContext.Provider>
  );
}
